import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";

function handleEditProjectRequest(
  project: Identifiable<Project>,
  req: Boundaries["editProject"]["request"],
): Identifiable<Project> {
  return project.uuid === req.project.uuid
    ? { ...project, ...req.nextProject }
    : project;
}

function handleEditProjectSuccess(
  project: Identifiable<Project>,
  nextProject: Boundaries["editProject"]["success"],
): Identifiable<Project> {
  return project.uuid === nextProject.uuid
    ? { ...project, ...nextProject }
    : project;
}

function handleEditProjectFailure(
  project: Identifiable<Project>,
  req: Boundaries["editProject"]["failure"],
): Identifiable<Project> {
  return project.uuid === req.project.uuid ? req.project : project;
}

export {
  handleEditProjectRequest,
  handleEditProjectSuccess,
  handleEditProjectFailure,
};
